'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderFetch = orderFetch;
exports.orderUserFetch = orderUserFetch;
exports.orderDeliveryEstimate = orderDeliveryEstimate;
exports.orderPaymentMethodsFetch = orderPaymentMethodsFetch;
exports.orderUpdate = orderUpdate;
exports.orderNext = orderNext;
exports.lineItemRemove = lineItemRemove;
exports.orderClose = orderClose;

var _actions = require('../helpers/actions');

function orderFetch(pageName) {
  return {
    type: 'ORDER_FETCH',
    promise: function promise(_ref) {
      var api = _ref.api;
      return api('/order').get({ pageName: pageName });
    }
  };
}

function orderUserFetch(id) {
  return {
    type: 'ORDER_USER_FETCH',
    promise: function promise(_ref2) {
      var api = _ref2.api;
      return api('/order/' + id).get();
    }
  };
}

function orderDeliveryEstimate() {
  return {
    type: 'ORDER_DELIVERY_ESTIMATE',
    promise: function promise(_ref3) {
      var api = _ref3.api;
      return api('/order/estimate_shipping_rates').get();
    }
  };
}

function orderPaymentMethodsFetch() {
  return {
    type: 'PAYMENT_METHODS_FETCH',
    promise: function promise(_ref4) {
      var api = _ref4.api;
      return api('/order/payment_methods').get();
    }
  };
}

function orderUpdate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: 'ORDER_UPDATE',
    promise: function promise(_ref5) {
      var api = _ref5.api,
          dispatch = _ref5.dispatch;
      return (0, _actions.handleErrors)(api('/order').post(data), dispatch);
    }
  };
}

function orderNext(state) {
  return {
    type: 'ORDER_NEXT',
    promise: function promise(_ref6) {
      var api = _ref6.api;
      return (0, _actions.handleErrors)(api('/order/next').put({ state: state }));
    }
  };
}

function lineItemRemove(lineItemId) {
  return {
    type: 'LINE_ITEM_REMOVE',
    promise: function promise(_ref7) {
      var api = _ref7.api,
          dispatch = _ref7.dispatch;
      return (0, _actions.handleErrors)(api('/order/line_items/' + lineItemId).delete(), dispatch);
    }
  };
}

function orderClose() {
  return { type: 'ORDER_CLOSE' };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/order.js
// module id = 223
// module chunks = 0